import { IOverlayParameter, IResult, IHeatParameter, IOverlayDelete, IOverlayClusterParameter, IPointSymbol, IDrawOverlays } from "@/types/map";

export class DrawOverlays {
  private static intances: Map<string, any>;
  private view!: AMap.Map;
  private _id: string | undefined = undefined;
  private _type: string | undefined = undefined;
  private group: any;
  private _callback: any;
  private mouseTool: any;
  private overlayGroups: Map<string, AMap.OverlayGroup> = new Map();
  private constructor(view: any) {
    this.view = view;
  }
  //唯一性
  public static getInstance(view: AMap.Map) {
    let id = view.getContainer().id;
    if (!DrawOverlays.intances) {
      DrawOverlays.intances = new Map();
    }
    let intance = DrawOverlays.intances.get(id);
    if (!intance) {
      intance = new DrawOverlays(view);
      DrawOverlays.intances.set(id, intance);
    }
    return intance;
  }

  public async startDrawOverlays(params: IDrawOverlays): IPromise<void> {
    this._callback = params.callback || undefined;
    this.group = this.getOverlayGroup(params.type || "default");
    //画线画面方法
    this.createOverLay(params);
  }
  public createOverLay(params: any) {
    this.mouseTool = new (AMap as any).MouseTool(this.view);
    if (params.drawType == "polyline") {
      this.mouseTool.polyline({
        strokeColor: params.symbol.color ? params.symbol.color : "#FF33FF",
        strokeWeight: params.symbol.strokeWeight ? params.symbol.strokeWeight : 6,
        strokeStyle: params.symbol.strokeStyle ? params.symbol.strokeStyle : "solid",
      });
    } else if (params.drawType == "polygon") {
      this.mouseTool.polygon({
        strokeColor: params.symbol.color ? params.symbol.color : "#FF33FF",
        strokeOpacity: params.symbol.strokeOpacity ? params.symbol.strokeOpacity : 0.4,
        strokeWeight: params.symbol.strokeWeight ? params.symbol.strokeWeight : 6,
        strokeStyle: params.symbol.strokeStyle ? params.symbol.strokeStyle : "solid",
        fillColor: params.symbol.fillColor ? params.symbol.fillColor : "#1791fc",
        fillOpacity: params.symbol.fillOpacity ? params.symbol.fillOpacity : 0.4,
      });
    }

    this.mouseTool.on("draw", (event: any) => {
      // event.obj 为绘制出来的覆盖物对象 event.obj.getOptions()
      this._callback({
        geometry: event.obj.getOptions(),
        center: undefined,
        data: {
          type: "drawOverlays",
          overlays: {
            geometry: event.obj,
            path: event.obj.getPath(),
            fields: {
              id: params.id,
              type: "drawOverlays",
            },
            id: params.id,
            symbol: params.symbol,
          },
        },
      });
    });
    this.view.on("dblclick", e => {
      this.mouseTool.close();
    });
  }
  public async stopDrawOverlays() {
    this.view.on("dblclick", e => {
      this.mouseTool.close();
    });
  }
  //获取绘画结果
  public async getDrawOverlays(): Promise<IResult> {
    // console.log(this.overlayGroups);
    this.overlayGroups.forEach(item => {
      // console.log(item.getOverlays(), '数据');
    });
    return new Promise((resolve: any, reject: any) => {});
  }
  //生成图层
  private getOverlayGroup(type: string): AMap.OverlayGroup {
    let group = this.overlayGroups.get(type);
    if (!group) {
      group = new AMap.OverlayGroup();
      this.view.add(group as any);
      this.overlayGroups.set(type, group);
    }
    return group;
  }
}
